import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import IAEOChecklist from '../../Interfaces/IAEOChecklist'
import AEOService from '../../Services/Catalogos/ArchivoElectronico.Services'
import { useEffect, useState } from 'react'
import { IconContext } from 'react-icons'
import { BsFillPencilFill } from 'react-icons/bs'
import { set } from 'cypress/types/lodash'
import { MsgInformativo } from '../Utils/Toast/msgInformativo'

type Props = {}

export default function RptAEOConfig({}: Props) {
  const [Data, setData] = useState<IAEOChecklist[]>([])
  const [Id, setId] = useState(0)
  const [Matching, setMatching] = useState('')
  const [Extension, setExtension] = useState('')
  const [Activo, setActivo] = useState(true)
  const colsData = [
    {
      name: 'id',
      width: '60px',
      selector: (row: IAEOChecklist) => row.id,
      sortable: true
    },
    {
      name: '',
      width: '60px',
      cell: (row: IAEOChecklist) => (
        <Button
          size="sm"
          variant="light"
          style={{
            textAlign: 'right'
          }}
          onClick={() => {
            setId(row.id)
            setMatching(row.inicia)
            setExtension(row.extension)
            setActivo(row.activo)
            setModalData(true)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '15px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>{' '}
        </Button>
      )
    },
    {
      name: 'Matching',
      width: '230px',
      selector: (row: IAEOChecklist) => row.inicia,
      sortable: true
    },
    {
      name: 'Extension',
      width: '100px',
      selector: (row: IAEOChecklist) => row.extension,
      sortable: true
    },
    {
      name: 'Activo',
      width: '100px',
      selector: (row: IAEOChecklist) => (row.activo ? 'Sí' : 'No'),
      sortable: true
    }
  ]
  const [ModalData, setModalData] = useState(false)
  const [show, setShowMsg] = useState(false)
  const [header, setHeader] = useState('')
  const [msg, setMsg] = useState('')
  const [msgColor, setMsgColor] = useState('primary')

  const generaReporte = () => {
    AEOService.getAEOChecklist()
      .then((response) => {
        setData(response.data)
      })
      .catch((e: Error) => {})
  }

  const saveAEOChecklist = () => {
    const data: IAEOChecklist = {
      id: Id,
      inicia: Matching,
      extension: Extension,
      activo: Activo
    }
    console.log(data)
    AEOService.appendAEOChecklist(data)
      .then((response) => {
        generaReporte()
        setId(0)
        setModalData(!ModalData)
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg('Ocurrio un error: ' + e)
        setShowMsg(true)
      })
  }

  useEffect(() => {
    generaReporte()
  }, [])

  const initiateModalData = () => {
    setId(0)
    setMatching('') 
    setExtension('')
    setActivo(true)
    setModalData(true)
  }

  return (
    <>
      <div>
        <Row style={{ paddingTop: '20px' }}>
          <Col xs={4}></Col>
          <Col xs={4}>
            <Card>
              <Card.Body>
                <Card.Title>
                  Configuración del Archivo Electrónico Oficial <span className="material-symbols--fiber-new-rounded" onClick={()=>{initiateModalData()}} style={{ cursor: 'pointer' }}></span>
                </Card.Title>
                <Card.Text>
                  <DataTable
                    noDataComponent={'No hay registros que mostrar'}
                    noHeader
                    defaultSortFieldId={'id'}
                    defaultSortAsc={true}
                    striped={true}
                    dense={true}
                    paginationPerPage={20}
                    pagination
                    highlightOnHover
                    columns={colsData}
                    data={Data}
                    pointerOnHover
                  />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={4}></Col>
        </Row>
      </div>
      <Modal
        show={ModalData}
        onHide={() => setModalData(false)}
        centered
        enforceFocus={true}
        className="modal-sino"
      >
        <Modal.Header closeButton>
          <Modal.Title>Favor de confirmar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={2}>Matching</Col>
            <Col xs={10}>
              <Form.Control
                type="text"
                placeholder=""
                size="sm"
                value={Matching}
                onChange={(e) => setMatching(e.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ paddingTop: '20px' }}>
            <Col xs={2}>Extension</Col>
            <Col xs={4}>
              <Form.Control
                type="text"
                placeholder=""
                size="sm"
                value={Extension}
                onChange={(e) => setExtension(e.target.value)}
              />
            </Col>
            <Col xs={1}></Col>
            <Col xs={2} style={{ textAlign: 'right' }}>
              Activo
            </Col>
            <Col xs={3}>
              <Form.Select
                aria-label="Default select example"
                size="sm"
                defaultValue={Activo ? '1' : '0'}
                onChange={(e) => setActivo(e.target.value === '1' ? true : false)}
              >
                <option value="1">Si</option>
                <option value="0">No</option>
              </Form.Select>
            </Col>
          </Row>
          <Row style={{ paddingTop: '20px' }}>
            <Col xs={2}>
              <Button variant="secondary" onClick={() => setModalData(false)}>
                Cerrar
              </Button>
            </Col>
            <Col xs={7}></Col>
            <Col xs={2} style={{ textAlign: 'right' }}>
              <Button
                variant="primary"
                onClick={() => {
                  saveAEOChecklist()
                }}
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <MsgInformativo
        show={show}
        msg={msg}
        header={header}
        msgColor={msgColor}
        closeToast={() => {
          setShowMsg(false)
        }}
      />
    </>
  )
}
